import { combineReducers } from 'redux';
import PrestacionesReducer from './PrestacionesReducer';
import SociosReducer from './SociosReducer';
import AuthReducer from './AuthReducer';

export default combineReducers({
  Admin: PrestacionesReducer,
  SociosReducer: SociosReducer,
  AuthReducer: AuthReducer
  });
  
